import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Toggle from 'react-toggle';
import Select from 'react-select';
import InputMask from 'react-input-mask';
import { Modal } from 'react-bootstrap';

class PlanningsEditVacations extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      key: 1,
      planning_id: this.props.match.params.id,
      staff_id: null,
      staff_vacation_id: null,
      days: null,
      extra_salary: false,
      file: null,
      start: null,
      finish: null,
      modal: false,
      staffs_select: [],
      staff_vacations_select: [],
      planning_staffs: [],
      import_alerts: undefined,

    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.botaoEdicao = this.botaoEdicao.bind(this);
    this.delete = this.delete.bind(this);
    this.add = this.add.bind(this);
    this.importCsv = this.importCsv.bind(this);
    this.openModal = this.openModal.bind(this);
  }

  // Handlers
  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleSelectChangeStaff(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
      change['staff_vacation_id'] = null;
    } else {
      var header = this.refs.request_api.header('application/json');
      var self = this;
      this.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/lista/colaborador/ferias/'+event.value, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if(responseJson.status == 'success') {
            self.setState({
              staff_vacations_select: responseJson.data,
            });
          }
          self.handleAlert('', '', 'closed');
        }).catch((error) => {
          console.error(error);
        });
      });   
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/planejamento/ferias/info/edicao/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/colaboradores');
        if (responseJson.status === 'success') {
          self.setState({
            planning_staffs: responseJson.data.planning_staffs,
            staffs_select: responseJson.data.staffs_select,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      });
    });
  }


  add(event) {
    event.preventDefault();
    var datasave = {
      planning_id: this.state.planning_id,
      staff_id: this.state.staff_id,
      staff_vacation_id: this.state.staff_vacation_id,
      days: this.state.days,
      extra_salary: this.state.extra_salary,
      start: this.state.start,
      finish: this.state.finish,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/cadastrar/colaborador/ferias', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if(responseJson.status == 'success') {
          self.setState({
            planning_staffs: responseJson.data,
          });
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });   
  }


  delete(id) {
    if(window.confirm('Tem certeza que deseja deletar as férias desse colaborador?')) {
      var header = this.refs.request_api.header('application/json');
      var self = this;
      this.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/deletar/colaborador/ferias/'+id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if(responseJson.status == 'success') {
            self.setState({
              planning_staffs: responseJson.data,
            });
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });   
    }
  }
  
  openModal () {
    this.setState({modal: true, file: undefined})
  }
  
  
  importCsv(event) {
    event.preventDefault();
    var self = this;
    var data = new FormData();
    var csv_file = document.querySelector(`input[name="filecsv"]`).files[0];
    data.append("file", csv_file);
    data.append("id",  self.props.match.params.id);
    var header = this.refs.request_api.header();
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/planejamento/ferias/importar/csv', {
        method: 'POST',
        mode: 'cors',
        headers: value,
        body: data }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          if (responseJson.status === 'success') {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
            self.setState({
              modal: false,
              file: undefined,
              import_alerts: undefined,
              planning_staffs: responseJson.data,
            });
          } else {
            self.setState({
              import_alerts: responseJson.data,
              file: undefined,
            });
            self.handleAlert('', '', 'closed');
          }
        }).catch((error) => {
        console.error(error);
      });
    });   
  }



  botaoEdicao (cell, row) {

    var botao = (
      <button className={'btn btn-danger btn-sm'} onClick={() => this.delete(cell)}>
        <i className="fa fa-fw fa-trash"></i>
      </button>
    );

    return botao;
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-fluid">
    <div className="conteudo">
      <h3 className="page-title pull-left">Edição do planejamento</h3>
      <div className="grid-buttons pull-right">
        <button  className="btn btn-info" onClick={self.openModal}><i className="fa fa-upload"></i> Importar</button>
        <Link to="/planejamentos/ferias" className="btn btn-default"><i className="fa fa-chevron-left"></i> Voltar</Link>
      </div>
      <div className="clearfix"></div>
      <hr/>
      <h4>Adicionar colaborador</h4>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Colaborador:</label>
            <Select
              className=""
              name="staff_id"
              value={this.state.staff_id}
              searchable={true}
              placeholder={'Selecionar gestores'}
              onChange={this.handleSelectChangeStaff.bind(this, 'staff_id')}
              options={this.state.staffs_select}
              required
            />
          </div>
          <div className="col-md-6 form-group">
            <label>Vencimento de férias:</label>
            <Select
              className=""
              name="staff_vacation_id"
              value={this.state.staff_vacation_id}
              searchable={true}
              placeholder={'Selecionar vencimento'}
              onChange={this.handleSelectChange.bind(this, 'staff_vacation_id')}
              options={this.state.staff_vacations_select}
              required
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Dias de férias (dd):</label>
            <input type="number" className="form-control" name="days" value={this.state.days} onChange={this.handleChange.bind(this, 'days')} required />
          </div>
          <div className="col-md-6 form-group">
            <label>Adiantamento 13º</label>
            <br/>
            <Toggle
              checked={this.state.extra_salary}
              aria-label='No label tag'
              name="extra_salary"
              onChange={this.handleToggleChange.bind(this, 'extra_salary')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Data de Início:</label>
            <InputMask value={this.state.start}  maskChar={null} name="start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'start')} placeholder="" required />
          </div>
          <div className="col-md-6 form-group">
            <label>Data de Término:</label>
            <InputMask value={this.state.finish}  maskChar={null} name="finish" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'finish')} placeholder="" required />
          </div>
        </div>
        <hr/>
        <button type={'submit'} className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Salvar</button>
      </form>
      <hr />
      <BootstrapTable data={this.state.planning_staffs} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: 'Não há planejamentos de férias cadastrados'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='50'>#</TableHeaderColumn>

        <TableHeaderColumn dataField="staff_inscription" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='100'>Matrícula</TableHeaderColumn>
        <TableHeaderColumn dataField="staff_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>Colaborador</TableHeaderColumn>
        <TableHeaderColumn dataField="staff_regime" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='150'>Quinzena</TableHeaderColumn>
        <TableHeaderColumn dataField="staff_post" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='150'>Cargo</TableHeaderColumn>
        <TableHeaderColumn dataField="staff_role" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='150'>Função</TableHeaderColumn>
        <TableHeaderColumn dataField="staff_base" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='150'>Base</TableHeaderColumn>
        <TableHeaderColumn dataField="vacation_end_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='150'>Vencimento de férias</TableHeaderColumn>
        <TableHeaderColumn dataField="days" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='80'>Dias de férias</TableHeaderColumn>
        <TableHeaderColumn dataField="extra_salary_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='100'>Adiantamento do 13º</TableHeaderColumn>
        <TableHeaderColumn dataField="start_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='150'>Data de Início</TableHeaderColumn>
        <TableHeaderColumn dataField="finish_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='150'>Data de Término</TableHeaderColumn>

        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.botaoEdicao} width='80'>Ações</TableHeaderColumn>
        
      </BootstrapTable>
    </div>

  </div>
  <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg">
    <Modal.Header>
      <h4 className="pull-left">Importar planejamento de férias</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false, import_alerts: undefined, file: null})}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <form onSubmit={this.importCsv}>
        <div className="form-group">
          <label>Arquivo csv:</label>
          <input type="text" type="file" name="filecsv" className={"form-control"} placeholder="Arquivo" value={this.state.file} onChange={this.handleChange.bind(this, 'file')} />
        </div>     
        <div className="form-group">
          <button className="btn btn-success btn-block" type="submit"><i className="fa fa-fw fa-save"></i> Importar</button>
        </div>
      </form>
      {
      (typeof self.state.import_alerts !== 'undefined') ?
        <div>
          <h4><strong>Erros de importação:</strong></h4>
          {Object.keys(self.state.import_alerts).map(function(k) {
            var alert = self.state.import_alerts[k];
            return(
              <div className={"box-alert box-alert-danger"}>
                  <div dangerouslySetInnerHTML={{__html: alert}}></div>
              </div>
            );
          })}
          <hr/>
        </div>
      :
        ''
      }
      <hr />
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false, import_alerts: undefined, file: null})}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default PlanningsEditVacations;



// WEBPACK FOOTER //
// ./src/Components/Plannings/PlanningsEditVacations.js